import { Injectable } from "@angular/core";
import { AdvancedRosterSearch } from "src/app/model/advanced-roster-search.model";
import { CplVerificationStage } from "src/app/model/cpl-verification-stage.model";
import { CplItemSubType } from "src/app/model/enum/cpl-item-sub-type.enum";


@Injectable()
export class BaseItemHelpersService {
    getAllApprovers(stages: CplVerificationStage[]) : { UserID: string, DisplayName: string }[] {
        return stages
            .map(stage => stage.Approvers)                                      // Get an array of arrays of approvers
            .filter(approvers => !!approvers)                                   // filter out any undefinded approver arrays
            .reduce((arr, a) => arr.concat(a), [])                              // flatten the approver arrays into a single array
            .reduce((arr, approver) =>  {                                       // filter out any repeates and simplify the format
                if (!arr.find(x => x.UserID === approver.UserID)) {
                    arr.push({ UserID: approver.UserID, DisplayName: approver.DisplayName })
                }
                return arr
            }, []);
    }

    isAdvancedSearchActive(advancedRosterSearch: AdvancedRosterSearch) {
        return !!(advancedRosterSearch.ApproverUserId || (advancedRosterSearch.GroupIDs?.length ?? 0) > 0);
    }

    getItemSubTypeLabel(subType?: CplItemSubType) {
        switch (subType) {
            case CplItemSubType.CLEARANCE:
                return 'Clearance';
            case CplItemSubType.FLEX:
                return 'Flex';
            default:
                return 'None';
        }
    }
}